module.exports = __webpack_public_path__ + "static/img/brees-2003-slide-4.689986c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2003-slide-4.jpg
// module id = YTbG
// module chunks = 1